export enum CoreActionTypes {
  CORE_INIT = '[Core] Init',
  LOG_OUT = '[Core] Log Out',
  LOG_OUT_SUCCESS = '[Core] Log Out Success',
  CORE_ERROR = '[Core] Error',
  CORE_INIT_TEAMS_AND_WORKSPACES = '[Core] Init Teams And Workspaces',
  TOGGLE_SWITCHING_TEAM = '[Core] Toggle Switching Team',
  TOGGLE_SWITCHING_WORKSPACE = '[Core] Toggle Switching Workspace',
  SWITCH_TEAM = '[Core] Switch Team',
  SWITCH_WORKSPACE = '[Core] Switch Workspace'
}
